var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((4),function(tier){return _c('DarkMatterDimensionRow',{key:tier,attrs:{"tier":tier}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }